import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconImage';
/** Renders an SVG icon. */
const SvgImage = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.15 24.76a1 1 0 0 0 .093-.091l3.889-4.32L13.4 22.8a1 1 0 0 0 1.4-.2l5.141-6.855 5.72 8.8a1 1 0 0 0 .19.215A2 2 0 0 1 24 26H8a2 2 0 0 1-1.85-1.24M26 21.396l-5.162-7.941A1 1 0 0 0 19.2 13.4l-5.4 7.2-3.2-2.4a1 1 0 0 0-1.343.131L6 21.95V8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2zM4 24a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V8a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4zm7.5-11a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3M8 11.5a3.5 3.5 0 1 0 7 0 3.5 3.5 0 0 0-7 0"
      />
    </svg>
  );
};
SvgImage.displayName = displayName;
export default SvgImage;
